import * as React from 'react';
import {classify} from 'src/utils/classify';
import makeClassNameComponent, {
  ClassNameComponent,
  makeClassNameComponentCustom,
} from 'src/utils/makeClassNameComponent';

import css from './core.css';
import dsCss from 'designSystem2021';

// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
export const PaddedRoundedBox: ClassNameComponent = makeClassNameComponent(
  classify(dsCss.defaultPadded, dsCss.defaultRoundedCorner),
  undefined,
  'PaddedRoundedBox',
);

// @ts-expect-error - TS2322 - Type 'AbstractComponent<Readonly<{ className?: string | undefined; }>, HTMLDivElement>' is not assignable to type 'ClassNameComponent<ClassNameComponent>'.
export const ClickableBox: ClassNameComponent<typeof PaddedRoundedBox> =
  makeClassNameComponentCustom(classify(dsCss.boxClickable), PaddedRoundedBox);

// @ts-expect-error - TS2322 - Type 'AbstractComponent<Readonly<{ className?: string | undefined; }>, HTMLDivElement>' is not assignable to type 'ClassNameComponent<ClassNameComponent>'.
export const SelectedBox: ClassNameComponent<typeof PaddedRoundedBox> =
  makeClassNameComponentCustom(classify(dsCss.boxSelected), PaddedRoundedBox);

// @ts-expect-error - TS2322 - Type 'AbstractComponent<Readonly<{ className?: string | undefined; }>, HTMLDivElement>' is not assignable to type 'ClassNameComponent<ClassNameComponent>'.
export const DefaultBackgroundBox: ClassNameComponent<typeof PaddedRoundedBox> =
  makeClassNameComponentCustom(
    classify(dsCss.boxDefaultBackground),
    PaddedRoundedBox,
  );

// @ts-expect-error - TS2322 - Type 'AbstractComponent<Readonly<{ className?: string | undefined; }>, HTMLDivElement>' is not assignable to type 'ClassNameComponent<ClassNameComponent>'.
export const DefaultWhiteBox: ClassNameComponent<typeof PaddedRoundedBox> =
  makeClassNameComponentCustom(
    classify(dsCss.boxDefaultWhite),
    PaddedRoundedBox,
  );

// @ts-expect-error - TS2322 - Type 'AbstractComponent<Readonly<{ className?: string | undefined; }>, HTMLDivElement>' is not assignable to type 'ClassNameComponent<ClassNameComponent>'.
export const ErrorBox: ClassNameComponent<typeof PaddedRoundedBox> =
  makeClassNameComponentCustom(classify(dsCss.boxError), PaddedRoundedBox);
